/* globals console, document, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const jQuery = require('jquery'),
    _ = require('lodash'),
    Marionette = require('backbone.marionette'),
    formProcessor = require('../utilities/formProcessor').processor, // @acavan! - need use specific processors
    // templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'modal-dialog modal-rts',
        role: 'document'
    },
    events: {
        'click button': 'onClickButton'
    },
    tagName: 'div',
    //
    close: function () {
        jQuery('#screenReaderAnnouncementsAssertive').text('Dialog closed');
        jQuery(document).off('keyup', _.bind(this.onKeyup, this));
        jQuery(document).off('keydown', _.bind(this.onKeydown, this));
        this.modal.empty();
        this.modal.modal('hide');
        this.modal.modal('dispose');
        if (this.options.modalModal) {
            jQuery('#modal').modal('show');
            jQuery('#modal').modal('handleUpdate');
        }
        this.destroy();
        this.trigger('modalDialog:closed');
    },
    initialize: function () {
        this.scrollTop = jQuery(document).scrollTop();
        // console.log('modalDialog.initialize - scrollTop:%s', this.scrollTop);
        this.modal = jQuery(this.options.modalModal ? '#modalModal' : '#modal');
        this.templateContext = this.options.templateContext || {};
        this.render();
    },
    onClickButton: function (event) {
        const action = event.currentTarget.dataset.action;
        let form,
            knownAction = false,
            serializedArray;
        switch (action) {
            case 'save':
                form = jQuery('form', this.modal);
                if (form[0].checkValidity()) {
                    this.trigger('modalDialog:save', formProcessor(jQuery('form', this.modal).serializeArray(), 'filter')); // @acavan! just pass up the serialized array?
                    if (!event.currentTarget.dataset.prologue) {
                        this.close();
                    } else {
                        this.$el.find('[data-prologue=hide]').addClass('d-none');
                        this.$el.find('[data-prologue=show]').removeClass('d-none');
                        this.$el.find('[data-prologue=disable]').prop('disabled', true);
                    }
                } else {
                    form.toggleClass('was-validated', true);
                }
                break;
            case 'cancel':
            case 'delete':
                knownAction = true; // jshint ignore:line
                // intentionally fall through...
            default:
                if (!knownAction) {
                    console.log('create.onClickButton - action:%s', action);
                }
                this.close();
                this.trigger('modalDialog:' + action);
                break;
        }
        return false;
    },
    onKeydown: function (event) {
        if (event.which === 9 && document.activeElement === this.focusable[!event.shiftKey ? this.focusable.length - 1 : 0]) {
            this.focusable[!event.shiftKey ? 0 : this.focusable.length - 1].focus();
            event.preventDefault();
        }
    },
    onKeyup: function (event) {
        let selector,
            element;
        switch (event.which) {
            case 27: // escape
                // console.log('modalDialog.keyup - escape');
                selector = '[data-action=cancel]';
                break;
            default:
                break;
        }
        if (selector) {
            element = this.$el.find(selector);
            if (!element.attr('disabled')) {
                element.trigger('click');
            }
        }
    },
    onRender: function () {
        if (this.options.modalModal) {
            jQuery('#modal').modal('hide');
        }
        this.$el.append('<div class="iframe-marker" data-iframe-height="1"></div>');
        this.modal.html(this.$el);
        this.modal.modal({backdrop: 'static', focus: false, keyboard: false});
        if (this.$el.find('.video-size').length > 0) {
            this.$el.addClass('video-big');
        }
        // stop any embedded videos when dialog closed.
        // PostMessage method here:
        // https://stackoverflow.com/questions/7443578/youtube-iframe-api-how-do-i-control-a-iframe-player-thats-already-in-the-html#7513356
        this.modal.off('hide.bs.modal').on('hide.bs.modal', function () {
            jQuery(this).find('.js-video-embed').each(function () {
                this.contentWindow.postMessage(JSON.stringify({
                    'event': 'command',
                    'func': 'stopVideo',
                    'args': []
                }), '*');
                // jQuery(this).stopVideo();
            });
        });
        jQuery(document).on('keyup', _.bind(this.onKeyup, this));
        jQuery(document).on('keydown', _.bind(this.onKeydown, this));
        this.focusable = this.$el.find('a[href], area[href], input, input:radio, select, textarea, button, [tabindex="0"]').filter(':not(disabled)').filter(':visible');
        this.focusable[0].focus();
        return this;
    }
});
